import { modalInitiliazation } from '@msc-b2c/shared-utils';

import { Modal } from './Modal';
import { occupancyInput } from '../occupancyInput/occupancy';

function onDocumentReady() {
  'use strict';

  const selectors = {
    self: 'cmp-modal',
  };
  const modals = document.querySelectorAll(`.${selectors.self}`);

  if (modals && modals.length > 0) {
    modals.forEach((modal) => {
      const options = {
        modal: modal as HTMLElement,
      };
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const _modalObj = new Modal(options);
    });
  }

  const MutationObserver =
    window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
  const body = document.querySelector('body');
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      // needed for IE
      const nodesArray = Array.from(mutation.addedNodes) as HTMLElement[];
      if (nodesArray.length > 0) {
        nodesArray.forEach(function (addedNode) {
          if (addedNode instanceof HTMLElement) {
            const elementsArray = Array.from(addedNode.querySelectorAll(`.${selectors.self}`));
            elementsArray.forEach((element) => {
              // eslint-disable-next-line @typescript-eslint/no-unused-vars
              const _modalObj = new Modal({
                modal: element as HTMLElement,
              });
              modalInitiliazation();
              occupancyInput();
            });
          }
        });
      }
    });
  });

  if (body) {
    observer.observe(body, {
      subtree: true,
      childList: true,
      characterData: true,
    });
  }
}

(function () {
  if (document.readyState !== 'loading') {
    onDocumentReady();
  } else {
    document.addEventListener('DOMContentLoaded', onDocumentReady);
  }
})();
